// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"225":"layout","400":"faceset","826":"index"}[chunkId] || chunkId) + "-1778733020780.js";
};